module.exports = __webpack_public_path__ + "img/services-dttcs-01.f9736fd6.svg";